import React from 'react'
import { HighlightCard } from 'ui/cards'
import { Translation } from '@morningtrain/react-translations'
import * as UI from 'ui'
import WhenOrderIsUnhandled from 'pages/app/inventory/order/partials/WhenOrderIsUnhandled'
import { useValue } from '@morningtrain/react-resources'
import WhenCanHandleOrderForOffice from 'pages/app/inventory/order/partials/WhenCanHandleOrderForOffice'

export default function InventoryOrderUnhandledHighlightCard (props) {
  const note = useValue('office_note')

  return (
    <WhenCanHandleOrderForOffice>
      <WhenOrderIsUnhandled>
        <HighlightCard
          title={<Translation name='inventory.fragments.unhandled_box_title' />}
          content={note}
          color='yellow'
          box={<UI.Icons.ExclamationCircle />}
        />
      </WhenOrderIsUnhandled>
    </WhenCanHandleOrderForOffice>
  )
}
